import { createReducer, on } from "@ngrx/store";
import { initialRedirectState } from "./redirect.state";
import { storeRedirectParams, clearRedirectParams } from "./redirect.actions";

export const redirectReducer = createReducer(
	initialRedirectState,
	on(storeRedirectParams, (state, { queryParams, path }) => ({
		...state,
		queryParams,
		url: path
	})),
	on(clearRedirectParams, () => initialRedirectState)
);
